var React = require('react');

function Facebook (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M14.5398 6.65667H16.0004V4.11267C15.7484 4.078 14.8818 4 13.8725 4C11.7667 4 10.3242 5.32467 10.3242 7.75933V10H8.00037V12.844H10.3242V20H13.1733V12.8447H15.4031L15.7571 10.0007H13.1726V8.04133C13.1733 7.21933 13.3946 6.65667 14.5398 6.65667Z","fill":"black"}));
}

Facebook.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = Facebook;

Facebook.default = Facebook;
